module.exports = __webpack_public_path__ + "static/media/computer@2x.f78637f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/computer@2x.png
// module id = 1408
// module chunks = 49